import { Module } from 'vuex';
import { DetectionRuleState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: DetectionRuleState = {
    rules: undefined,
    ruleDetails: {
        rule: undefined,
        ruleGroups: undefined,
    },
    ruleCount: 0,
    search: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    create: {
        isProcessing: false,
        isCreated: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    show: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    update: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    destroy: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    csv: {
        isProcessing: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
};

const namespaced: boolean = true;

export const detectionRule: Module<DetectionRuleState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
